
  export enum OsLicenseModel {
    BRING_YOUR_OWN_LICENSE = "BRING_YOUR_OWN_LICENSE",
    NO_LICENSE_REQUIRED = "NO_LICENSE_REQUIRED",
  }